import script from "./PlantManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantManager.vue?vue&type=script&setup=true&lang=js"

import "./PlantManager.vue?vue&type=style&index=0&id=32454e2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32454e2f"]])

export default __exports__